/** @jsx jsx */

import { clients } from "utils/clients";
import { jsx, Variable, StringScalar, render, Mutation, SelectionSet, Field, IdScalar, IntScalar } from "graphql-jsx";

type Option = Readonly<{
  artistId: string;
  typeUrl: string;
  url: string;
  order?: number;
}>;

export const CreateArtistUrl = async (option: Option) => {
  const $artistId = <Variable name="artistId" scalar={<IdScalar />} value={option.artistId} />;
  const $typeUrl = <Variable name="type_url" scalar={<StringScalar isNullable={false} />} value={option.typeUrl} />;
  const $url = <Variable name="url" scalar={<StringScalar isNullable={false} />} value={option.url} />;
  const $order = <Variable name="order" scalar={<IntScalar isNullable />} value={option.order} />;
  const { query, variables } = render(
    <Mutation operationName="CREATE_ARTIST_URL">
      <SelectionSet
        name="updateArtist"
        alias="createArtistUrl"
        argument={{
          where: {
            artist_id: $artistId
          },
          data: {
            _onlySearch: true,
            artist_url: {
              create: [{ type_url: $typeUrl, url: $url, exposure_order: $order }]
            }
          }
        }}
      >
        <Field name="artist_id" alias="artistId" />
        <SelectionSet name="artist_url">
          <Field name="id" alias="uuid" />
          <Field name="type_url" alias="typeUrl" />
          <Field name="url" />
        </SelectionSet>
      </SelectionSet>
    </Mutation>
  );

  type Data = Readonly<{
    createArtistUrl: {
      artistId: string;
      artist_url: {
        uuid: string;
        typeUrl: string;
        url: string;
      }[];
    };
  }>;

  return await clients.artist.request<Data>(query, variables);
};
